import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { Column } from '@prisjakt/ui/list/variants';
import { H3Text } from '@prisjakt/ui/text/variants';

export const NoResult = styled(Column)`
  text-align: left;
  padding: 0 ${layout.measurements.spacing050};
  margin: ${layout.measurements.spacing100} 0;
`;

export const PopularSearchesTitle = styled(H3Text)`
  text-align: left;
  padding: 0 ${layout.measurements.spacing100};
  margin: ${layout.measurements.spacing100} 0;
`;

export const Strikeover = styled.span`
  text-decoration: line-through;
`;

export const ListTitle = styled.p`
  margin: 0 ${layout.measurements.spacing050};
`;

export const List = styled.ul`
  margin-left: ${layout.measurements.spacing150};
`;

export const ListItem = styled.li`
  margin: 0 ${layout.measurements.spacing050};
`;

export const NoSearchResultWrapperPic = styled.img`
  margin-left: ${layout.measurements.spacing050};
  padding-top: ${layout.measurements.spacing100};
  padding-bottom: ${layout.measurements.spacing150};
`;
